// extracted by mini-css-extract-plugin
export default {"navbar":"Header_navbar__Gew18","link":"Header_link__jrd00","customToggler":"Header_customToggler__tuyWb"};